function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import backend from "../../utils/backend";
import * as actionTypes from "../../constants/actionTypes";

export var typingUserSettings = function typingUserSettings(obj) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.TYPING_USER_SETTINGS,
      payload: obj
    });
  };
};

var submitUserSettings = function submitUserSettings(obj) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.SUBMIT_USER_SETTINGS
    });

    // Omit subscriptions and saved_stories from request otherwise backend will think we are trying to change subscriptions and saved_stories

    var subscriptions = obj.subscriptions,
        saved_stories = obj.saved_stories,
        data = _objectWithoutProperties(obj, ["subscriptions", "saved_stories"]); // eslint-disable-line no-unused-vars

    return backend.request({
      method: "PATCH",
      url: "/readers/update/",
      data: data
    }).then(function () {
      dispatch({
        type: actionTypes.SUBMIT_USER_SETTINGS_SUCCESS,
        payload: data
      });
    }).catch(function (err) {
      dispatch({
        type: actionTypes.SUBMIT_USER_SETTINGS_ERROR,
        payload: err
      });
    });
  };
};

export { submitUserSettings };
export var getSubscriptions = function getSubscriptions() {
  return function (dispatch) {
    dispatch({
      type: actionTypes.GET_USER_SUBSCRIPTIONS
    });

    return backend.request({
      method: "GET",
      url: "/subscriptions/"
    }).then(function (response) {
      dispatch({
        type: actionTypes.GET_USER_SUBSCRIPTIONS_SUCCESS,
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: actionTypes.GET_USER_SUBSCRIPTIONS_ERROR,
        payload: err
      });
    });
  };
};

export var toggleCheckbox = function toggleCheckbox(subscriptions, name, checked) {
  return function (dispatch) {
    var newSubscriptions = subscriptions;

    if (checked) {
      newSubscriptions = newSubscriptions.concat(name);
    } else {
      newSubscriptions = newSubscriptions.filter(function (subscription) {
        return subscription !== name;
      });
    }

    dispatch({
      type: actionTypes.CHANGE_USER_SUBSCRIPTIONS,
      payload: newSubscriptions
    });
  };
};

export var submitSubscriptions = function submitSubscriptions(subscriptionIds) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.SUBMIT_USER_SUBSCRIPTIONS
    });

    return backend.request({
      method: "PATCH",
      url: "/readers/update/",
      data: {
        subscriptions: subscriptionIds
      }
    }).then(function () {
      dispatch({
        type: actionTypes.SUBMIT_USER_SUBSCRIPTIONS_SUCCESS
      });
    }).catch(function (err) {
      dispatch({
        type: actionTypes.SUBMIT_USER_SUBSCRIPTIONS_ERROR,
        payload: err
      });
    });
  };
};

export var submitSavedStories = function submitSavedStories(savedStoryIds) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.SUBMIT_USER_SAVED_STORIES
    });

    return backend.request({
      method: "PATCH",
      url: "/readers/update/",
      data: {
        saved_stories: savedStoryIds
      }
    }).then(function () {
      dispatch({
        type: actionTypes.SUBMIT_USER_SAVED_STORIES_SUCCESS,
        payload: savedStoryIds
      });
    }).catch(function (err) {
      dispatch({
        type: actionTypes.SUBMIT_USER_SAVED_STORIES_ERROR,
        payload: err
      });
    });
  };
};

export var deleteAccount = function deleteAccount() {
  return function (dispatch) {
    dispatch({
      type: actionTypes.DELETE_ACCOUNT
    });

    return backend.request({
      method: "DELETE",
      url: "/readers/delete/"
    }).then(function () {
      dispatch({
        type: actionTypes.DELETE_ACCOUNT_SUCCESS
      });
    }).catch(function (err) {
      dispatch({
        type: actionTypes.DELETE_ACCOUNT_ERROR,
        payload: err
      });
    });
  };
};

export var changePassword = function changePassword(passwords) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.CHANGE_PASSWORD
    });

    return backend.request({
      method: "POST",
      url: "/readers/update-password/",
      data: {
        password: passwords.password,
        password1: passwords.password1,
        password2: passwords.password2
      }
    }).then(function () {
      dispatch({
        type: actionTypes.CHANGE_PASSWORD_SUCCESS
      });
    }).catch(function (err) {
      dispatch({
        type: actionTypes.CHANGE_PASSWORD_ERROR,
        payload: err
      });
    });
  };
};


// WEBPACK FOOTER //
// ./src/users/actions/userSettings.js